import { postDocumentsCancelSigning } from '../../../cancel-signing';

/**
 * POST 서명 취소 - 입력한 서명을 취소합니다.
 *
 * @deprecated This API is forwarded. Due to the path is changed in standardize-document-content
 * @see https://www.notion.so/modusign/bb8e24e723434ecc946dfecb85db5ee3#a84e2868f0b84f4d872c7f5f629e7bfa
 */
export function postDocumentsParticipantsSigningCancellation({
  documentId,
  message,
  participantId,
  workspaceId,
}: {
  documentId: string;
  message: string;
  participantId: string;
  workspaceId: string;
}) {
  return postDocumentsCancelSigning({
    documentId,
    message,
    participantId,
    workspaceId,
  });
}
